import React from 'react';
import classnames from 'classnames';
import { Modal, ModalProps } from '@instinet-analytics/semantic-ui-components';

import './SettingsModal.scss';

export default function SettingsModal(
    props: React.PropsWithChildren<ModalProps>
) {
    return (
        <Modal
            {...props}
            className={classnames(props.className, 'SettingsModal')}
        />
    );
}
